import React from 'react';
import { Mail, Phone, MapPin, Download } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-brand">
              <img 
                src="https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/6rf6onic_885ea933-b00e-4489-80dc-ff243e4d3458-removebg-preview.png" 
                alt="GREEN ART Landscape & Gardening Services logo" 
                className="footer-logo-image"
              />
            </div>
            <p className="footer-tagline">
              Creating sustainable green spaces that thrive in the UAE's unique desert climate
            </p>
            <a 
              href="https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/l1h5scva_GREEN%20ART%20LANDSCAPE%20COMPANY%20PROFILE%202026_compressed%20%281%29.pdf"
              download="Green-Art-Company-Profile-2026.pdf"
              className="btn-download-link"
            >
              <Button 
                variant="outline"
                className="btn-download"
              >
                <Download className="w-5 h-5" />
                Download Company Profile
              </Button>
            </a>
          </div>

          <nav className="footer-column" aria-label="Quick Links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#hero">Home</a></li>
              <li><a href="#about-section">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#projects-section">Projects</a></li>
              <li><a href="#certifications">Certifications</a></li>
              <li><a href="#quote-section">Get Quote</a></li>
            </ul>
          </nav>

          <div className="footer-column" aria-label="Our Services">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li>Softscaping</li>
              <li>Hardscaping</li>
              <li>Landscape Design</li>
              <li>Irrigation Systems</li>
              <li>Swimming Pools</li>
              <li>Green Houses</li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <Phone className="w-5 h-5" />
                <a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a>
              </li>
              <li>
                <Mail className="w-5 h-5" />
                <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
              </li>
              <li>
                <MapPin className="w-5 h-5" />
                <span>{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Green Art Landscape & Gardening Services L.L.C. All rights reserved.
          </p>
          <div className="footer-certifications">
            <span>ISO 9001:2015</span>
            <span>•</span>
            <span>ISO 14001:2015</span>
            <span>•</span>
            <span>ISO 45001:2018</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
